import React, { FC } from "react";
import useEdgeExperiment from "../../hooks/useEdgeExperiment";
import BuildBanner from "../BuildBanner";
import GlobalPromoBanner from "../GlobalPromoBanner";
import Navbar from "../Navbar";
import NavbarSearchBC from "../NavbarSearchBC";
import Footer from "../Footer";
import { PageDefaults } from "../../hooks/usePageDefaults";

interface Props { children: any }

const Layout: FC<Props> = ({ children }) => {
  const election = useEdgeExperiment('search_prominence');
  const variantId = election?.variantId || 1;
  let navBar;

  switch (variantId) {
    case 3:
    case 2:
      navBar = <NavbarSearchBC />;
      break;
    case 1:
    default:
      navBar = <Navbar />;
      break;
  }
  
  return (
    <PageDefaults>
      <BuildBanner />
      <GlobalPromoBanner />
      {navBar}
      {children}
      <Footer />
    </PageDefaults>
  );
};

export default React.memo(Layout);
